// extracted by mini-css-extract-plugin
module.exports = {"box":"DailyTask_box_10FUT","banner":"DailyTask_banner_3gEXD","content":"DailyTask_content_3QGip","item":"DailyTask_item_3Ch-7","accomplish":"DailyTask_accomplish_i5Kf6"};